export default class OrphanAssignmentItem {
  constructor(item) {
    if (item) {
      this.AsSassieAsgnId = item.asSassieAsgnId;
      this.AsEvname = item.asEvname;
      this.AsSassieSurveyId = item.asSassieSurveyId;
      this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
      this.LgsDesc = item.lgsDesc;
      this.CcCompanyName = item.ccCompanyName;
      this.CuName = item.cuName;
      this.CuCity = item.cuCity;
      this.CuState = item.cuState;
      this.CuCountry = item.cuCountry;
      return;
    }
    this.AsSassieAsgnId = '';
    this.AsEvname = '';
    this.AsSassieSurveyId = '';
    this.AsEvaluatorCompletedDate = '';
    this.LgsDesc = '';
    this.CcCompanyName = '';
    this.CuName = '';
    this.CuCity = '';
    this.CuState = '';
    this.CuCountry = '';
  }

  static DateFields = ['AsEvaluatorCompletedDate'];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Client', orderById: 'CcCompanyName', data: 'CcCompanyName', minWidth: 40 },
      { label: 'Survey ID', orderById: 'AsSassieSurveyId', data: 'AsSassieSurveyId', minWidth: 40 },
      { label: 'Location', orderById: 'CuName', data: 'CuName', minWidth: 40 },
      { label: 'Country', orderById: 'CuCountry', data: 'CuCountry', minWidth: 40 },
      { label: 'Apollo ID', orderById: 'AsSassieAsgnId', data: 'AsSassieAsgnId', minWidth: 40 },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 40 },
      { label: 'Completed On', orderById: 'AsEvaluatorCompletedDate', data: 'AsEvaluatorCompletedDate', minWidth: 40 },
      { label: 'City', orderById: 'CuCity', data: 'CuCity', minWidth: 40 },
      { label: 'State', orderById: 'CuState', data: 'CuState', minWidth: 40 },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname', minWidth: 40 },
    ];
  }
}
